import { Layers } from 'lucide-react';

const BADGE_CLS = { bull: 'dr-bull', bear: 'dr-bear', watch: 'dr-wtch' };
const CLS_MAP   = { fact: 'cls-fact', strong_inference: 'cls-sinf', weak_inference: 'cls-winf', missing_data: 'cls-miss' };

export default function DriversCard({ sym, date, drivers = [] }) {
  return (
    <div className="drivers-card">
      <div className="drivers-head">
        <Layers size={15} /> Projection drivers · {sym} · {date}
      </div>
      {drivers.map((d, i) => (
        <div key={i} className="driver-row">
          <span className={`dr-badge ${BADGE_CLS[d.sentiment] ?? 'dr-wtch'}`}>
            {d.sentiment === 'bull' ? 'Bull' : d.sentiment === 'bear' ? 'Bear' : 'Watch'}
          </span>
          <div className="driver-body">
            <div className="driver-title">{d.title}</div>
            <div className="driver-detail">{d.detail}</div>
            {d.periods?.length > 0 && (
              <div className="driver-tags">
                {d.periods.map(p => <span key={p} className="driver-tag">{p}</span>)}
              </div>
            )}
          </div>
          <span className={`driver-cls ${CLS_MAP[d.claim] ?? 'cls-miss'}`}>{d.claim}</span>
        </div>
      ))}
    </div>
  );
}
